(() => {
	function e(e, t) {
		var mouseEntered = false;

		var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
			i = document.getElementById(e),
			r = i.getBoundingClientRect(),
			o = t ? r.left : r.right,
			d = i.querySelector(":first-child");

		function l() {
			if (mouseEntered == false) {
				var e = t
						? d.querySelector("article:first-child")
						: d.querySelector("article:last-child"),
					i = t
						? e.getBoundingClientRect().right
						: e.getBoundingClientRect().left;
				(t ? i <= o : i >= o) &&
					((n = t ? -1 : 1), t ? d.appendChild(e) : d.prepend(e)),
					(d.style.marginLeft = "".concat(n, "px")),
					(n = t ? n - 1 : n + 1);
			}
			window.requestAnimationFrame(l);
		}

		window.requestAnimationFrame(l);

		i.addEventListener("mouseenter", function () {
			mouseEntered = true;
		});

		i.addEventListener("mouseleave", function () {
			mouseEntered = false;
		});
	}

	document.addEventListener("DOMContentLoaded", function (t) {
		e("marquee-top", 1, -45),
			e("marquee-middle", 0, -45),
			e("marquee-logos", 1, -45);
	});
})();

// Case studies
document.addEventListener("DOMContentLoaded", function () {
	var $tabCutoutContainer = jQuery(".tab-content--cutout");

	jQuery('button[data-toggle="tab"]', "#works").on(
		"shown.bs.tab",
		function (event) {
			// event.target; // newly activated tab
			// event.relatedTarget; // previous active tab
			var id = jQuery(event.target).attr("id");

			$tabCutoutContainer.find(".tab-pane").removeClass("show active");

			var $tab = jQuery('.tab-pane-cutout[aria-labelledby="' + id + '"]');
			$tab.addClass("show active");
		}
	);

	jQuery("#homeContentGallery").owlCarousel({
		items: 1,
		margin: 24,
		dots: false,
		nav: true,
	});
});
